import _ from 'lodash';
import axios from 'axios';
import io from 'socket.io-client';

import * as chatInitAction from '../actions/chatInitAction';
import { updateInsiders } from '../actions/insidersAction';

import {
  CHAT_WILL_END,
  WELCOME_SURVEY_SUBMIT,
  chatDidEnd,
  soundPlay,
} from '../actions/chatInitAction';
import {
  error,
  warning,
  notification
} from '../actions/alertAction';
import {
  LUSER_TOGGLE_FOLLOW,
  LUSER_FOLLOW,
  LUSER_UNFOLLOW,
  LUSER_SET_FOLLOW,
  threadFollow,
  threadUnfollow
} from '../actions/luserAction';
import {
  THREADS_SUBMIT,
  THREADS_MESSAGE_SUBMIT,
  THREADS_DELETE,
  THREADS_MESSAGE_DELETE,
  THREADS_MESSAGE_DELETED,
  THREADS_MESSAGE_IAM_TYPING,
  add as threadAdd,
  message_add as threadMessageAdd,
  deletedThread,
  deletedMessage,
  user_typing
} from '../actions/threadsAction';
import {
  insiderNotificationReceived,
  INSIDERS_NOTIFICATION_SUBMIT
} from '../actions/insidersAction';
import { getTranslator } from '../../locales';

var typerTimeout = false;
var socketManager, socket = null;
var connected = false;
var reconnected = false;
var totalReconnectionAttempts = 0;
var lastPing = false;
var userTimeout = process.env.USER_TIMEOUT || 5000;


/*
** Stream action/event to the chat server using POST request
*/
export function chatMiddleware(store) {

  return next => action => {
    const result = next(action);
    const serverUrl = store.getState().chat.serverUrl;
    const livechatId = store.getState().chat.id;
    const t = getTranslator();

    if (socket) {
      if (action.type === THREADS_MESSAGE_IAM_TYPING) {
        // will emit only once when typing,
        // and then always emit when not typing anymore
        if (
          typerTimeout === false ||
          action.payload.status === false
        ) {
          typerTimeout = true;

          let data = { 'is_typing': action.payload.status };

          if (action.payload.thread_id) {
            data.thread_id = action.payload.thread_id;
          }
          socket.emit('user:typing', data);

          if (action.payload.status === false) {
            typerTimeout = false;
          }
        }
      } else if (action.type === THREADS_SUBMIT) {
        axios.post(
          serverUrl + '/sessions/' + livechatId + '/threads' + '?' + (new Date().getTime()), 
          action.payload,
          { withCredentials: true })
        .then(response => {
          if (response.status !== 201) {
            store.dispatch(
              warning(
                t.t('Sorry, an error occurred.') + ' (THREADS_SUBMIT > ' + response.status + ').'
              )
            );
          }
        })
        .catch(err => {
          if (('' + err).match(/400/)) {
            store.dispatch(warning(t.t('Sorry, your message is too long.')));
          } else {
            store.dispatch(warning(t.t('Sorry, an error occurred.') + ' (THREADS_SUBMIT > ' + err + ').'));
          }
        });
      } else if (action.type === THREADS_MESSAGE_SUBMIT) {
        axios.post(
          serverUrl + '/threads/' + action.message.threadId + '/messages' + '?' + (new Date().getTime()), 
          action.message,
					{ withCredentials: true })
        .then(response => {
          if (response.status !== 201) {
            store.dispatch(
              warning(
                t.t('Sorry, an error occurred.') + ' (THREADS_MESSAGE_SUBMIT > ' + response.status + ').'
              )
            );
          }
        })
        .catch(err => {
          if (('' + err).match(/400/)) {
            store.dispatch(warning(t.t('Sorry, your message is too long.')));
          } else {
            store.dispatch(
              warning(
                t.t('Sorry, an error occurred.') + ' (THREADS_MESSAGE_SUBMIT > ' + err + ').'
              )
            );
          }
        });
      } else if (action.type === LUSER_TOGGLE_FOLLOW) {
        let followedThreadIds = store.getState().luser.followedThreadIds;
        let apiAction = null;
        const index = followedThreadIds.indexOf(action.thread_id);

        if (index >= 0) {
          apiAction = 'unfollow';
          followedThreadIds.splice(index, 1);
        } else {
          apiAction = 'follow';
          followedThreadIds.push(action.thread_id)
        }

        axios.post(
          serverUrl + '/threads/' + action.thread_id + '/' + apiAction + '?' + (new Date().getTime()),
          {},
					{ withCredentials: true })
          .then(response => {
            if (response.status !== 204) {
              store.dispatch(
                warning(
                  t.t('Sorry, an error occurred.') + ' (LUSER_TOGGLE_FOLLOW > ' + response.status+').'
                )
              );
            } else {
              store.dispatch({ type: LUSER_SET_FOLLOW, followedThreadIds });
            }
          })
          .catch(err => {
            store.dispatch(
              warning(
                t.t('Sorry, an error occurred.') + ' (LUSER_SET_FOLLOW > ' + err + ')'
              )
            );
          });
      } else if (action.type === LUSER_FOLLOW || action.type === LUSER_UNFOLLOW) {
        const apiAction = (action.type === LUSER_FOLLOW) ? 'follow' : 'unfollow';

        axios.post(
          serverUrl + '/threads/' + action.thread_id + '/' + apiAction + '?' + (new Date().getTime()),
          {},
					{ withCredentials: true })
          .then(response => {
            if (response.status !== 204) {
              store.dispatch(
                warning(
                  t.t('Sorry, an error occurred.') + ' (LUSER_TOGGLE_FOLLOW > ' + response.status + ').'
                )
              );
            }
          })
          .catch(err => {
            store.dispatch(
              warning(
                t.t('Sorry, an error occurred.') + ' (LUSER_SET_FOLLOW > ' + err + ')'
              )
            );
          });
      } else if (action.type === THREADS_DELETE) {
        if (action.threadId) {
          axios.delete(
            serverUrl + '/threads/' + action.threadId + '?' + (new Date().getTime()),
            { withCredentials: true })
            .then(response => {
              if (response.status !== 204) {
                store.dispatch(
                  warning(
                    t.t('Sorry, an error occurred.') + ' (THREADS_DELETE > ' + response.message ? response.message : response.status+').'
                  )
                );
              }
            })
            .catch(err => {
              store.dispatch(
                warning(
                  t.t('Sorry, an error occurred.') + ' (THREADS_DELETE > ' + err + ')'
                )
              );
            });
        }
      } else if (action.type === THREADS_MESSAGE_DELETE) {
        if (action.messageId) {
          axios.delete(
            serverUrl + '/messages/' + action.messageId + '?' + (new Date().getTime()),
            { withCredentials: true })
            .then(response => {
              if (response.status !== 204) {
                store.dispatch(
                  warning(
                    t.t('Sorry, an error occurred.') + ' (THREADS_MESSAGE_DELETE > ' + response.status + ').'
                  )
                );
              }
            })
            .catch(err => {
              store.dispatch(
                warning(
                  t.t('Sorry, an error occurred.') + ' (THREADS_MESSAGE_DELETE > ' + err + ')'
                )
              );
            });
        }
      } else if (action.type === INSIDERS_NOTIFICATION_SUBMIT) {
        if (action.notification) {
          axios.post(
            serverUrl + '/sessions/' + livechatId + '/insider_notifications' + '?' + (new Date().getTime()), 
            action.notification,
            { withCredentials: true })
            .then(response => {
              if (response.status !== 201) {
                store.dispatch(
                  warning(
                    t.t('Sorry, an error occurred.') + ' (CHAT_INSIDER_FORM_SUBMIT > ' + response.status + ').'
                  )
                );
              }
            })
            .catch(err => {
              store.dispatch(
                warning(
                  t.t('Sorry, an error occurred.') + ' (CHAT_INSIDER_FORM_SUBMIT > ' + err + ')'
                )
              );
            });
        }
      } else if (action.type === CHAT_WILL_END) {
        axios.post(
          serverUrl + '/sessions/' + livechatId + '/close' + '?' + (new Date().getTime()),
          {},
					{ withCredentials: true })
          .then(response => {
            if (response.status !== 204) {
              store.dispatch(
                warning(
                  t.t('Sorry, an error occurred.') + ' (CHAT_INSIDER_FORM_SUBMIT > ' + response.status + ').'
                )
              );
            }
          })
          .catch(err => {
            store.dispatch(
              warning(
                t.t('Sorry, an error occurred.') + ' (CHAT_INSIDER_FORM_SUBMIT > ' + err + ')'
              )
            );
          });
      } else if (action.type === WELCOME_SURVEY_SUBMIT) {
        axios.post(
          serverUrl + '/chat-sessions/' + livechatId + '/welcome-survey' + '?' + (new Date().getTime()), 
          action.data,
					{ withCredentials: true })
          .then(response => {
            if (response.status !== 204) {
              store.dispatch(
                warning(
                  t.t('Sorry, an error occurred.') + ' (WELCOME_SURVEY_SUBMIT > ' + response.status+').'
                )
              );
            }
          })
          .catch(err => {
            store.dispatch(
              warning(
                t.t('Sorry, an error occurred.') + ' (WELCOME_SURVEY_SUBMIT > ' + err + ')'
              )
            );
          });
      }
    }
    return result;
  };
}

/*
** Socket.io initialisation & event listening
*/
export default function (store) {
  console.log('*** ','socket.io connecting to ', store.getState().chat.serverUrl, '***');

  const opts = {
    forceNew: true,
    reconnection: true,
  };

  socketManager = window.manager = io.Manager(
    store.getState().chat.serverUrl,
    opts
  );

  return axios.get(
    store.getState().chat.serverUrl + '/sessions/' + store.getState().chat.id + '?' + (new Date().getTime()),
    { withCredentials: true })
    .then(response => {
      console.log('*** From chatMiddleware ***');
      const t = getTranslator();

      if (parseInt(response.status, 10) === 200) {
        socket = io.connect(
          store.getState().chat.serverUrl + '/sessions/' + store.getState().chat.id,
          opts
        );

        socket.on('connect', () => {
          console.log('SOCKET => connect');
          connected = true;

          if (reconnected) {
            store.dispatch(chatInitAction.load({ reconnect: true }));
          } else {
            store.dispatch(chatInitAction.load());
          }
        });

        socket.on('disconnect', function(reason) {
          console.log('SOCKET => disconnect', reason);
          connected = false;

          // Show disconnection notice
          if (reason !== 'io client disconnect') {
            store.dispatch(notification(
              t.t('Your computer seems to experience connectivity issues. Reconnecting%{connection_attempt}…', { 'connection_attempt': '' }),
              true
            ));
          }
        });

        socket.on('reconnecting', attemptNumber => {
          console.log('SOCKET => reconnecting', attemptNumber);
        });

        socket.on('reconnect_attempt', attemptNumber => {
          totalReconnectionAttempts++;
          console.log('SOCKET => reconnect_attempt', attemptNumber);
          console.log('SOCKET => totalReconnectionAttempts', totalReconnectionAttempts);

          const maxReconnectionAttempts = 3;
          let extra = '';

          // We switch to polling pransport after 2 unsuccessful
          // reconnection attempts
          if (totalReconnectionAttempts > maxReconnectionAttempts) {
            console.log('SOCKET => switching to polling transport');
            socket.io.opts.transports = ['polling'];

            extra = ' (safe mode)';
          } else {
            extra = ' (' + totalReconnectionAttempts + '/' + maxReconnectionAttempts + ')';
          }

          if (totalReconnectionAttempts > 7) {
            console.log('SOCKET => Stop reconnections');
            socket.disconnect();

            // Display disconnection notification with a reload link
            store.dispatch(notification(
              t.t('Your computer seems to experience connectivity issues. Reconnecting%{connection_attempt}…', { 'connection_attempt': extra }),
              true,
              true
            ));
          } else {
            // Display disconnection notification
            store.dispatch(notification(
              t.t('Your computer seems to experience connectivity issues. Reconnecting%{connection_attempt}…', { 'connection_attempt': extra }),
              true
              )
            );
          }
        });

        socket.on('reconnect', function(attemptNumber) {
          reconnected = true;
          console.log('SOCKET => reconnect', attemptNumber);

          // @TODO: avoid socket reconnect in case we close the chat
          // This is a bit hacky.
          // We check if the chat is closed in case of reconnection
          // There is a slight timing issue when closing the chat and socket
          // gets reconnected somehow
          if (!_.isNil(store.getState().chat) && !store.getState().chat.closed) {
            // store.dispatch( chatInitAction.load() );
            // window.location.reload();
          }
        });

        socket.on('ping', function(data) {
          lastPing = new Date();
          // console.log('••• --> Server PING');
          if (typeof data !== 'undefined') {
            if (data && typeof data.insidersOnline !== 'undefined' && data.insidersOnline[0] !== null){
              // Updating Online Insiders
              store.dispatch( updateInsiders(data.insidersOnline) );
            }
          }
        });

        setInterval(function() {
          if (!connected) {
            return;
          }

          if (lastPing && (new Date() - lastPing) > userTimeout * 3) {
            console.log('*** ','Gaps with ping  ', store.getState().chat.serverUrl, '***');

            // User is behind, we need to refresh chat content
            if (reconnected) {
              store.dispatch(chatInitAction.load({ reconnect: true }));
            } else {
              store.dispatch(chatInitAction.load());
            }
          };

          if (socket) {
            console.log('••• --> Emit alive ping');
            socket.emit('alive', new Date());
          }
        }, userTimeout);

        socket.on('connectedUsersUpdate', function(nb)
        {
          console.log('••• --> connectedUsersUpdate', nb)
          store.dispatch( chatInitAction.updateConnectedUsers(nb) );
        });

        socket.on('newThread', thread =>
        {
          console.log('••• --> newThread received', thread)
          store.dispatch( threadAdd(thread) );
        });

        socket.on('newMessage', message =>
        {
          console.log('••• --> newMessage received', message)
          store.dispatch( threadMessageAdd(message) );
        });

        socket.on('user:typing', data =>
        {
          if (data.user.id !== store.getState().luser.id){
            console.log('••• --> user:typing received', data)
            store.dispatch( user_typing(data) );
          }
        });

        socket.on('deleteThread', thread_id =>
        {
          console.log('••• --> deleteThread received', thread_id)
          store.dispatch( deletedThread(thread_id) );
          store.dispatch( threadUnfollow(thread_id) );
        });

        socket.on('deleteMessage', data =>
        {
          console.log('••• --> deleteMessage received', data)
          store.dispatch( deletedMessage(data.threadId, data.messageId) );
        });

        socket.on('newInsiderNotification', data =>
        {
          console.log('••• --> newInsiderNotification received', data)
          store.dispatch( insiderNotificationReceived(data) );
        });

        socket.on('insiderLeave', data =>
        {
          console.log('••• --> insiderLeave received', data)
        });

        socket.on('endOfChat', data =>
        {
          console.log('••• --> endOfChat received', data)
          store.dispatch( chatDidEnd() );
        });

        socket.on('reopenChat', data =>
        {
          console.log('••• --> reopenChat received', data)
          // TODO
          // store.dispatch( chatDidEnd() );
        });

        return socket;
      } else {
        // clearTimeout(loaderTimeout);
        store.dispatch( error(
          t.t('Sorry, an error occurred.')
          + '(Could not connect to the chat server)'
        ));
      }
    }).catch(err => {
      if (
        _.has(err, 'response.status') &&
        parseInt(err.response.status, 10) === 401
      ) {
        store.dispatch(error('NOT_LOGGED_IN'));

        if (socket) {
          socket.close();
          // @TODO Remove event listeners on the socket object.
          console.log('SOCKET => Disconnect');
        }
      } else {
        const t = getTranslator();
        store.dispatch(error(
          t.t('Sorry, an error occurred.') + `
          ` + '(' + err + ')'
        ));
      }
    });
}



// WEBPACK FOOTER //
// ./src/redux/middlewares/chatMiddleware.jsx